// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"87":"026f2a0fc188ea0b55c3ee41f782b6e40dfc1225","262":"component---src-pages-docs-mdx-slug-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"87":"9af79c9af7a428ee88c2","262":"6edca8a3d832c868bfcd","678":"7745c2c1b8a54f833802","883":"cb5351f054aeb7e393ce"}[chunkId] + ".js";
};